<mat-spinner *ngIf="loading"></mat-spinner>

<div *ngIf="!loading">
    <div class="app-base">
        <mat-chip-list>
            <mat-chip *ngFor="let appointment of appointments" [selected]="isSelected(appointment)" (click)="setCurrentProcedure(appointment)">
                {{ getName(appointment) }}
                <mat-icon *ngIf="!readonly && canRemove()" (click)="remove(appointment)">cancel</mat-icon>
            </mat-chip>
        </mat-chip-list>
    </div>

    <app-integrated-admission-appointment></app-integrated-admission-appointment>

    <button *ngIf="showAddAppointment() && !readonly" (click)="addNewAppointment()" type="button" style="z-index: 1000; position: fixed; bottom: 210px; right: 15px" mat-fab color="primary">
    <mat-icon>add</mat-icon>
  </button>

    <button *ngIf="showCopyAppointment() && !readonly && !proceduresGroupedRequired()" (click)="addNewCopyAppointment()" type="button" style="z-index: 1000; position: fixed; bottom: 150px; right: 15px" mat-fab color="primary">
    <mat-icon>content_copy</mat-icon>
  </button>
    <button *ngIf="showCopyAppointment() && proceduresGroupedRequired() && !readonly" (click)="groupProcedures()" type="button" style="z-index: 1000; position: fixed; bottom: 150px; right: 15px" mat-fab color="primary">
    <mat-icon>call_split</mat-icon>
  </button>

    <button *ngIf="showPrint()" (click)="print()" type="button" style="z-index: 1000; position: fixed; bottom: 150px; right: 15px" mat-fab color="primary">
    <mat-icon>print</mat-icon>
  </button>

    <button type="button" (click)="finish()" [disabled]="finishDisabled" *ngIf="!readonly" style="z-index: 1000; position: fixed; bottom: 90px; right: 15px" mat-fab>
    <mat-icon>done</mat-icon>
  </button>
</div>
